
  import { WordInterface } from "@/models/words"
  import { defineComponent } from "@vue/runtime-core"

  export default defineComponent({
    name: "AccordionAnswer",
    props: {
      words: Object as WordInterface | any
    },
    setup(props: any, { emit }: any) {
      const deleteAnswer = (word: string) => emit("deleteAnswer", word)

      return { deleteAnswer }
    }
  })
